export default __webpack_public_path__ + "static/SiemensProgress-Bol-master-800959d733a6d0a9920cf8c1c5ffd17d.ttf";